import { Star } from 'lucide-react';
import { useDefaultSuite } from '../hooks/useDefaultSuite';

interface DefaultSuiteButtonProps {
  suiteId: string;
  disabled?: boolean;
}

/** Makes `suiteId` the default suite of the eval pages in this browser, or clears it. */
export const DefaultSuiteButton = ({ suiteId, disabled }: DefaultSuiteButtonProps) => {
  const [defaultSuiteId, setDefaultSuiteId] = useDefaultSuite();
  const isDefault = suiteId !== '' && suiteId === defaultSuiteId;
  const label = isDefault ? 'Default suite in this browser. Click to clear.' : 'Make this the default suite in this browser';

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      aria-pressed={isDefault}
      disabled={disabled || suiteId === ''}
      onClick={() => setDefaultSuiteId(isDefault ? null : suiteId)}
      className={`shrink-0 p-1.5 rounded-md transition-colors disabled:opacity-50 ${
        isDefault ? 'text-amber-500 hover:bg-amber-50' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
      }`}
    >
      <Star size={16} fill={isDefault ? 'currentColor' : 'none'} />
    </button>
  );
};
